export default __webpack_public_path__ + "static/media/david_zhu.1bc9181f.jpg";